import { Field, TAnswer } from "src/shared/contexts/HackerContext/types";
import { notNull } from "src/shared/utils/validation";

export const ACCEPTED_FIELDS = [
  Field.LEGAL_NAME,
  Field.AGE_18,
  Field.SHORT_BIRTHDATE,
  Field.GUARDIAN_NAME,
  Field.GUARDIAN_CONTACT,
  Field.WAIVER_CONSENT,
  Field.WAIVER_SIGNATURE,
  Field.WAIVER_HASH,
  Field.WAIVER_VERSION,
  Field.WAIVER_SIGNED_AT,
  Field.CONFIRMATION_RSVP_STAGE,
  Field.PERSONAL_RSVP_STAGE,
  Field.BADGE_RSVP_STAGE,
  Field.PROFILE_RSVP_STAGE,
];

export const VALIDATORS: Partial<Record<Field, (value: TAnswer) => boolean>> = {
  [Field.AGE_18]: notNull,
};

export { TERMS_AND_CONDITIONS_MD } from "./waiver-copy";
